import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { LegalNotices } from '@/features/content/LegalNotices';
import { MobileLegalNotices } from '@/features/content/mobile/MobileLegalNotices';

export const Route = createFileRoute('/_app/legal-notices')({ component: LegalNoticesRoute });

/** Selettore: note legali mobile (MaeDesign) vs lettore documenti desktop. */
function LegalNoticesRoute() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileLegalNotices /> : <LegalNotices />;
}
